import {
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutation,
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutationVariables,
} from '@/gql/graphql';
import { gql } from '@apollo/client';
import { TypedDocumentNode } from '@graphql-typed-document-node/core';

export const DELETE_FEIERTAGSKONTO_KONTOAUSGLEICH: TypedDocumentNode<
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutation,
  Mitarbeiter_DeleteFeiertagskontoKontoausgleichMutationVariables
> = gql`
  mutation mitarbeiter_deleteFeiertagskontoKontoausgleich(
    $input: mitarbeiter_deleteFeiertagskontoKontoausgleichInput!
  ) {
    mitarbeiter_deleteFeiertagskontoKontoausgleich(input: $input) {
      failure {
        message
      }
      success {
        id
      }
    }
  }
`;
